var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex center justify-center",attrs:{"id":"Upload"}},[_c('input',{staticClass:"pa3",attrs:{"type":"file","accept":"image/*","id":"file-input"},on:{"change":function($event){return _vm.uploadImage($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }